import React, { useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';

gsap.registerPlugin(ScrollTrigger);

const FallingText = () => {
    const containerRef = useRef(null);

    useGSAP(() => {
        // استهداف جميع الكلمات التي تحمل كلاس falling-word داخل السكشن
        gsap.from(".falling-word", {
            y: -350,                // تبدأ الكلمات ساقطة من أعلى بمقدار 150 بكسل
            opacity: 0,             // تبدأ مخفية تماماً
            rotate: -15,            // دوران خفيف جهة اليسار أثناء السقوط لإعطاء حركة طبيعية
            duration: 2.5,
            ease: "bounce.out",     // 🌟 تأثير الارتداد الفيزيائي (تتهز الكلمة لما تقع على الأرض)
            
            // 🔀 السر في التوالي: يجعل هناك فارق زمني 0.15 ثانية بين سقوط كل كلمة والتي تليها
            stagger: .15,          
            
            scrollTrigger: {
                trigger: containerRef.current,
                start: "top 30%",   // يبدأ الأنميشن أول ما السكشن يوصل لـ 60% من الشاشة
                end: "top",
                // toggleActions: "play none none reverse" -> يشتغل أول ما يدخل، ويعيد نفسه لو رجع سكرول لأعلى
                toggleActions: "play none none reverse", 
            }
        });
    }, { scope: containerRef });

    // الجملة المراد تطبيق التأثير عليها
    const text = "هيا بنا نصنع ما لا يمكن تصديقه 😉";
    // تحويل النص إلى مصفوفة من الكلمات
    const words = text.split(" ");

    return (
        <div ref={containerRef} style={sectionStyle}>
            
            {/* النص المتساقط */}
            <h1 style={textContainerStyle}>
                {words.map((word, index) => (
                    <span 
                        key={index} 
                        className="falling-word" 
                        style={word !== "😉" ? wordStyle : {} }
                    >
                        {word}
                    </span>
                ))}
            </h1>
            
            <p style={{ color: '#9ca3af', marginTop: '20px', fontSize: '1.2rem' }}>
                ...ما الذى تنتظره تواصل معنا الأن
            </p>
        </div>
    );
};

// 🎨 التنسيقات البصرية للسكشن (Inline Styles للتبسيط)
const sectionStyle = {
    background: '#0b0c10',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0 20px',
    overflow: 'hidden'
};

const textContainerStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '15px', // المسافة بين الكلمات
    direction: 'rtl', // لدعم اللغة العربية بشكل صحيح
    maxWidth: '900px',
    textAlign: 'center'
};

const wordStyle = {
    display: 'inline-block', // ⚠️ إجباري لكي يعمل الـ transform والـ y بشكل صحيح
    fontSize: '3.5rem',
    fontWeight: '900',
    background: 'linear-gradient(to right, #ffffff, #818cf8)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    willChange: 'transform, opacity'
};

export default FallingText;